import { Event } from '@tribeplatform/gql-client/types'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { ErrorBoundary } from '../../common/components/ErrorBoundary/ErrorBoundary.js'
import { MediaModalBoundary } from '../../MediaModal/MediaModalBoundary.js'
import { EventHeaderActions } from '../Components/EventHeaderActions.js'

import { LeftSideColumn } from './LeftSideColumn.js'
import { RightSideColumn } from './RightSideColumn.js'

interface EventDetailsProps {
  event: Event
  transparent?: boolean
}

export const EventDetails = ({ event, transparent }: EventDetailsProps) => {
  return (
    <ErrorBoundary>
      <MediaModalBoundary>
        <Card
          className="h-full border-none"
          padding="none"
          transparent={transparent}
        >
          <Card.Content className="flex flex-col sm:grid sm:grid-cols-[1fr_2fr] h-full">
            <div className="flex sm:hidden sticky top-0 bg-surface z-10 flex-col gap-y-2 rounded-t-base">
              <EventHeaderActions event={event} />
            </div>
            <LeftSideColumn event={event} />
            <div className="flex flex-col gap-y-2 min-w-0">
              <div className="hidden sm:flex sticky top-0 bg-surface z-10 flex-col gap-y-2 rounded-t-base">
                <EventHeaderActions event={event} />
              </div>
              <RightSideColumn event={event} />
            </div>
          </Card.Content>
        </Card>
      </MediaModalBoundary>
    </ErrorBoundary>
  )
}
